var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSelectCollectionGreen = function SvgIconSelectCollectionGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.334 20.003c0-9.184 7.483-16.667 16.667-16.667 9.183 0 16.666 7.483 16.666 16.667 0 9.183-7.483 16.666-16.666 16.666S3.334 29.186 3.334 20.003"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#429D15",
    d: "M20 3.336c-9.183 0-16.666 7.483-16.666 16.667 0 9.183 7.483 16.666 16.667 16.666 9.183 0 16.666-7.483 16.666-16.666S29.184 3.336 20.001 3.336m7.967 12.833-9.45 9.45a1.25 1.25 0 0 1-1.766 0l-4.717-4.716a1.26 1.26 0 0 1 0-1.767 1.26 1.26 0 0 1 1.767 0l3.833 3.833 8.567-8.566a1.257 1.257 0 0 1 1.766 0 1.257 1.257 0 0 1 0 1.766"
  })));
};
export default SvgIconSelectCollectionGreen;